import { on } from "delegated-events";
import ajax from "@common/ajax";
import { generateQueryString } from "@common/util";

const searchForm = document.querySelector(".search-form");
const forms = document.querySelectorAll(".filter-form");

const populateFilterState = () => {
  if (searchForm) {
    const filters = JSON.parse(searchForm.dataset.selectedFilters);

    const searchTerm = filters["search"];

    if (searchTerm) {
      searchForm.querySelector('[type="search"]').value = searchTerm;
    }
  }

  if (!forms.length) {
    return;
  }

  forms.forEach((form) => {
    const filters = JSON.parse(form.dataset.selectedFilters);

    const types = ["types"];

    types.forEach((type) => {
      if (type in filters) {
        filters[type].forEach((value) => {
          const field = form.querySelector(`[value="${value}"]`);

          if (field) {
            field.checked = true;
          }
        });
      }
    });
  });
};

const generateUrl = (form, params = {}) => {
  const queryString = generateQueryString(params);
  const url = queryString.size ? `${form.action}?${queryString}` : form.action;

  return url;
};

const handleSearchForm = (e) => {
  e.preventDefault();

  const form = e.target.closest("form");

  const url = generateUrl(form, new FormData(form));

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleFilterChange = (e) => {
  e && e.preventDefault();

  const form = e.target.closest("form");

  const selectedTypes = Array.from(form.querySelectorAll(".filter-type:checked"));

  const params = {};

  params.types = selectedTypes.map((x) => x.value).join("_");

  const url = generateUrl(form, params);

  window.history.replaceState({}, "", url);

  updateResults();

  if (searchForm) {
    searchForm.querySelectorAll("input").forEach((x) => (x.value = null));
  }
};

const handleFilterClear = () => {
  window.history.replaceState({}, "", searchForm.action);

  searchForm.querySelectorAll("input").forEach((x) => (x.value = null));

  document.querySelectorAll(".filter-form input:checked").forEach((x) => (x.checked = false));

  updateResults();
};

const updateResults = async () => {
  const pageContent = document.querySelector("[data-page-content]");

  if (pageContent) {
    pageContent.classList.add("is-loading");

    const res = await ajax.get(window.location.href).json();

    pageContent.innerHTML = res.page;
    pageContent.classList.remove("is-loading");

    const totalItems = parseInt(res.totalItems);
    const resultsTotal = totalItems === 1 ? `${totalItems} Result` : `${totalItems} Results`;

    document.querySelectorAll(".results-total-count").forEach((el) => {
      el.textContent = resultsTotal;
    });

    document.querySelectorAll(".filters-clear").forEach((x) => x.classList.toggle("hidden", !res.isFiltered));
  }
};

const init = () => {
  populateFilterState();

  on("change", ".filter-form input:not([type=hidden]):not([type=search])", handleFilterChange);
  on("click", ".filters-open", (e) => {
    document.documentElement.classList.add("overflow-hidden");

    const trigger = e.currentTarget;

    trigger.setAttribute("aria-expanded", "true");
  });

  on("click", ".filters-close", () => {
    document.documentElement.classList.remove("overflow-hidden");

    const trigger = document.querySelector(".filters-open");

    trigger.setAttribute("aria-expanded", "false");
  });

  on("submit", ".search-form", handleSearchForm);

  on("click", ".filters-clear", handleFilterClear);
};

init();
